import { HorizontalFlex, IconButton, Space } from "@enxcs/dap-ui-stratos";
import styled from "styled-components";

export const ResumeIconButton = styled(IconButton)`
  width: fit-content !important;
`;

export const ReadyToRecordButton = styled(ResumeIconButton)``;

export const ActionContainer = styled(HorizontalFlex)`
  justify-content: flex-end !important;
  padding-right: 36px;
  gap: ${Space.V4};
`;
